class NewsletterSignup extends HTMLElement {
  constructor() {
    super()
    this.newsletterForm = this.querySelector('.ft-Newsletter')
    this.emailField = this.querySelector('.ft-Newsletter_Input')

    if (!this.newsletterForm) return

    this.newsletterForm.addEventListener('submit', () => {
      try {
        this.bloomreachTrackEvent()
      } catch (error) {
        console.warn('Newsletter tracking failed', error)
      }
    })
  }

  bloomreachTrackEvent() {
    if (typeof exponea === 'undefined' || !this.emailField) return

    const email = this.emailField.value.toLowerCase().trim()

    exponea.identify({ email_id: email }, { email })

    exponea.track('consent', {
      action: 'accept',
      category: 'Marketing',
      valid_until: 'unlimited',
      message: "This consent was tracked from footer's newsletter signup form",
    })
  }
}

customElements.define('newsletter-signup', NewsletterSignup)
